<div class="settings" *ngIf="deviceSettingsService" [ngClass]="{ 'modal-open': deviceSettingsService.displayModal }">
  <div class="col">
    <div class="mic">
      <qai-icon
        class="mic-icon"
        [kind]="'microphone'"
        [color]="'#FFFFFF'"
        [size]="'22px'"
      />
      <qai-label
        class="mic-text"
        [kind]="'secondary'"
        [size]="'medium'"
        [weight]="'bold'"
      >
        {{'settings.MICROPHONE' | transloco}}
      </qai-label>
      <app-device-settings-audio-circles
        [decibels]="deviceSettingsService.decibels"
      ></app-device-settings-audio-circles>
    </div>
  </div>
  <div class="col">
    <app-device-settings-microphone-selection
      [deviceSettingsService]="deviceSettingsService"
    ></app-device-settings-microphone-selection>

    <!-- Diagnostic -->
    @if (isTavusCall && (!isCallActive || inModal())) {
      <app-device-settings-diagnostic [deviceSettingsService]="deviceSettingsService" (diagnosticRunningChange)="diagnosticRunningChange.emit($event)"></app-device-settings-diagnostic>
    }

    <!-- Error message -->
    <div class="error-message" *ngIf="deviceSettingsService.isDeviceBlocked">
      {{'settings.DEVICE_BLOCKED_ERROR' | transloco}}
    </div>
  </div>
</div>
